import { inject as service } from '@ember/service';
import { gt } from '@ember/object/computed';
import Controller from '@ember/controller';
import { task } from 'ember-concurrency';
import { action } from '@ember/object';
import EnvironmentService from 'cio/services/environment';
import ApiService from 'cio/services/api';
import DS from 'ember-data';
import { DEFAULT_PAGE, DEFAULT_SEARCH, DEFAULT_CATEGORY } from 'cio/utils/email-suppression-list';

export default class SuppressionListController extends Controller {
  @service environment!: EnvironmentService;
  @service store!: DS.Store;
  @service api!: ApiService;

  queryParams = ['page', 'category', 'email'];
  page = DEFAULT_PAGE;
  category = DEFAULT_CATEGORY;
  email = DEFAULT_SEARCH;

  setDefaults() {
    this.setProperties({
      page: DEFAULT_PAGE,
      email: DEFAULT_SEARCH,
      category: DEFAULT_CATEGORY,
    });
  }

  @gt('fetchMailServers.last.value.length', 0) hasCustomMailServers!: boolean;

  fetchMailServers = task(
    {
      drop: true,
    },
    async () => {
      return await this.store.findAll('mail-server');
    },
  );

  @action
  async exportSuppressedEmails() {
    return await this.api.request('exports/email_suppressions', {
      pathScope: 'environment',
      method: 'POST',
    });
  }
}
